<div class="hp-recent-modal-overlay"
  *ngIf="isVisible"
  (click)="toggleModal()">
  <div class="hp-recent-modal"
    (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="hp-recent-modal-header">
      <div class="hp-recent-modal-title">
        <i class="material-icons" style="color: #4CAF50;">inventory</i>
        <h3>Inventory Purchase Request</h3>
      </div>
      <button class="hp-recent-close-btn" (click)="toggleModal()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Loading State -->
    <div class="hp-recent-loading" *ngIf="isInventoryPrLoading && inventoryPrItems.length === 0">
      <div class="pm-spinner"></div>
      <span>Loading Inventory PRs...</span>
    </div>

    <div class="hp-recent-content" *ngIf="!isInventoryPrLoading || inventoryPrItems.length > 0" (scroll)="onInventoryPrScroll($event)">
      <div class="hp-recent-section" *ngIf="inventoryPrItems.length > 0">
        <div class="hp-pr-accordion">
          <div class="hp-pr-accordion-item" *ngFor="let req of inventoryPrItems">
            <!-- Header -->
            <div class="hp-pr-accordion-header" (click)="toggleInventoryPrRow(req)">
              <div class="hp-pr-header-left">
                <div class="hp-pr-icon-wrapper">
                  <i class="material-icons">inventory_2</i>
                </div>
                <div class="hp-pr-info">
                  <h6 class="hp-pr-title">Request Time: {{ (req.createdAt || req.created_at) ? ((req.createdAt || req.created_at) | date:'MMM d, y, h:mm a') : 'N/A' }}</h6>
                </div>
              </div>
              <div class="hp-pr-header-right">
                <span class="hp-pr-status" [ngClass]="(req.processStatus || req.process_status | lowercase) || 'pending'">
                  {{ req.processStatus || req.process_status || 'Pending' }}
                </span>
                <i class="material-icons hp-pr-chevron" [class.expanded]="req.expanded">keyboard_arrow_down</i>
              </div>
            </div>
            
            <!-- Body -->
            <div class="hp-pr-accordion-body" *ngIf="req.expanded">
              <div class="hp-pr-body-content">
                <!-- Select All Header -->
                <div class="hp-pr-select-all-header" *ngIf="getUnprocessedPrItemsCount(req) > 0">
                  <label class="hp-pr-checkbox-container">
                    <input type="checkbox"
                           [checked]="isPrSelectAllChecked(req)"
                           (change)="toggleSelectAllPrItems(req, $event)" />
                    <span class="hp-pr-checkbox-checkmark"></span>
                    <span class="hp-pr-select-all-text">Select All ({{ getUnprocessedPrItemsCount(req) }} items)</span>
                  </label>
                </div>

                <div class="hp-pr-tags">
                  <div class="hp-pr-tag"
                       *ngFor="let item of (req.itemDetails || req.item_details)"
                       [class.processed-tag]="isPrItemProcessed(item)"
                       [class.selected-tag]="item.selected && !isPrItemProcessed(item)">
                    <label class="hp-pr-checkbox-container" (click)="$event.stopPropagation()">
                      <input type="checkbox"
                             [(ngModel)]="item.selected"
                             [disabled]="isPrItemProcessed(item)" />
                      <span class="hp-pr-checkbox-checkmark"></span>
                    </label>

                    <div class="tag-content" (click)="toggleItemSelection(item)">
                      <span class="tag-name" [title]="item.name || item.itemName || item.item_name">
                        {{ item.name || item.itemName || item.item_name }}
                      </span>
                      <span class="tag-qty" *ngIf="item.qty || item.quantity || item.unit || item.uom">
                        {{ item.qty || item.quantity }} {{ item.unit || item.uom }}
                      </span>
                      <span class="tag-stock" *ngIf="item.closingStock !== undefined && item.closingStock !== null">
                        Stock: {{ item.closingStock }} <ng-container *ngIf="item.closingStockDate">| {{ item.closingStockDate | date:'MMM d, y, h:mm a' }}</ng-container>
                      </span>
                    </div>

                    <span class="hp-pr-item-processed-badge" *ngIf="isPrItemProcessed(item)">
                      <i class="material-icons">check_circle</i> Processed
                    </span>
                  </div>
                </div>
                
                <div class="hp-pr-action-buttons">
                  <button class="pm-add-selected-btn pm-btn-sm" 
                          (click)="searchSelectedInventoryPrItems(req)"
                          [disabled]="getSelectedPrItemsCount(req) === 0">
                    <i class="material-icons">search</i>
                    Search Selected ({{ getSelectedPrItemsCount(req) }})
                  </button>

                  <button class="pm-add-all-btn pm-btn-sm" 
                          (click)="searchAllInventoryPrItems(req)"
                          [class.added]="isInventoryPrRequestAdded(req)"
                          [disabled]="getUnprocessedPrItemsCount(req) === 0">
                    <i class="material-icons">{{ isInventoryPrRequestAdded(req) ? 'check' : 'search' }}</i>
                    {{ isInventoryPrRequestAdded(req) ? 'Completed' : 'Search All Items' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Load More Button -->
        <div class="hp-pr-load-more" *ngIf="inventoryPrHasMore">
          <button class="pm-load-more-btn" (click)="loadMoreInventoryPrItems()" [disabled]="isInventoryPrLoading">
            <span *ngIf="!isInventoryPrLoading">Load More</span>
            <span *ngIf="isInventoryPrLoading">Loading...</span>
          </button>
        </div>
      </div>

      <!-- Empty State -->
      <div class="hp-recent-empty"
        *ngIf="inventoryPrItems.length === 0 && !isInventoryPrLoading">
        <i class="material-icons">inventory_2</i>
        <h4>No Pending Requests</h4>
        <p>There are no pending inventory purchase requests.</p>
      </div>
    </div>
  </div>
</div>
